var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C1.63636 0 0 4 0 4C0 4 1.63636 8 6 8C10.3636 8 12 4 12 4C12 4 10.3636 0 6 0ZM6 1C8.87782 1 10.3334 3.13355 10.8047 3.99805C10.3329 4.85655 8.86636 7 6 7C3.12218 7 1.66659 4.86645 1.19531 4.00195C1.66768 3.14345 3.13364 1 6 1ZM6 2C4.79509 2 3.81818 2.8955 3.81818 4C3.81818 5.1045 4.79509 6 6 6C7.20491 6 8.18182 5.1045 8.18182 4C8.18182 2.8955 7.20491 2 6 2ZM6 3C6.60273 3 7.09091 3.4475 7.09091 4C7.09091 4.5525 6.60273 5 6 5C5.39727 5 4.90909 4.5525 4.90909 4C4.90909 3.4475 5.39727 3 6 3Z",
    fill: "#EDEDED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.c7b7aaa3f077a3ac845a611bfe81c278.svg";
export { ForwardRef as ReactComponent };